import { Directive, TemplateRef } from '@angular/core';
import { DatalistComponent } from './datalist.component';

@Directive({ selector: '[mriDataListStatistics]', standalone: true })
export class DatalistStatisticsDirective {
  constructor(statisticsTemplate: TemplateRef<never>, datalist: DatalistComponent) {
    datalist.customStatisticsTemplate = statisticsTemplate;
  }
}
